module.exports = {
  // 数字千分化
  formatNum(num) {
    let value = 0;
    if (num) {
      value = (+num).toLocaleString();
    }
    return value;
  },
  // 格式化空值
  filterEmptyText(val) {
    return val || '-';
  },
  // 数字保留两位小数
  fixed2(val) {
    if (isNaN(Number(val))) {
      return val
    } else {
      return Number(val).toFixed(2)
    }
  }
};
